<template lang="pug">
  section
    b-container
      h1 PAYOUTS
      b-nav
        b-nav-item(:to="{name: 'PayoutsEligible'}") ELIGIBLE
        b-nav-item(:to="{name: 'PayoutsHistory'}") HISTORY
    b-container.pt-2
      router-view
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Payouts.vue